import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { getWeather } from '../actions/weather';
import ClearSky from '../assets/images/weather/weather-clear-sky.svg';
import ClearSkyNight from '../assets/images/weather/weather-clear-sky-night.svg';
import FewClouds from '../assets/images/weather/weather-few-clouds.svg';
import FewCloudsNight from '../assets/images/weather/weather-few-clouds-night.svg';
import LotOfClouds from '../assets/images/weather/weather-scattered-clouds.svg';
import Rain from '../assets/images/weather/weather-rain.svg';
import moment from 'moment/moment';

class Weather extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.getWeather();
  }

  render() {
    const { dayOne } = this.props.weather;
    const day = dayOne;
    return (
      <Fragment>
        {day && day.length > 0 ? (
          <section className={`pt-4 ${this.props.background}`} id="weather">
            <div className="container mb-5 mt-5" style={{ fontSize: 20 }}>
              <div className="row">
                <div className="col-12">
                  <div className="row justify-content-between">
                    <div className="col-md-4 txt-regular mt-md-4 mt-sm-0 text-md-left text-sm-center">
                      <span className="txt-bold">Tunisie, </span>
                      <span className="txt-thin">Sousse</span>
                      <div className="txt-thin">{moment(new Date()).format('ddd DD MMM YYYY')}</div>
                    </div>
                    <div className="col-md-4 txt-regular text-sm-center">
                      <div className="row">
                        <div className="col-12 mt-sm-5">
                          <WeatherCondition large day={day[0].sys.pod} weatherCondition={day[0].weather[0].description} />
                        </div>
                        <span className="col-6 txt-regular">
                          <span className="txt-regular">Humidité</span>
                          <br />
                          <span className="txt-thin">{day[0].main.humidity}%</span>
                        </span>
                        <span className="col-6 txt-regular text-sm-center">
                          <span className="txt-regular">Vent</span>
                          <br />
                          <span className="txt-thin">
                            {day[0].wind.speed}
                            Km/h
                          </span>
                        </span>
                      </div>
                    </div>
                    <div className="col-md-4 text-md-right text-sm-center">
                      <div className="txt-bold txt-white live-temperature">
                        {Math.trunc(day[0].main.temp_max)}
                        <sup style={{ fontSize: 20 }}>
                          C° <span style={{ fontSize: 15 }}>max</span>
                        </sup>
                      </div>
                      <div className="txt-bold txt-white live-temperature">
                        {Math.trunc(day[0].main.temp_min)}
                        <sup style={{ fontSize: 20 }}>
                          C° <span style={{ fontSize: 15 }}>min</span>
                        </sup>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <DayWeather day={day} />
            </div>
          </section>
        ) : (
          <div className="pt-5 pb-5 txt-white">
            <span className="fas fa-circle-o-notch fa-5x fa-spin" />
          </div>
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = store => ({
  weather: store.weather,
});

export default connect(mapStateToProps, { getWeather })(Weather);

const DayWeather = props => (
  <div className="row justify-content-center">
    {props.day.map((weatherByTime, key) => (
      <div key={key} className="m-4 row flex-column align-items-center">
        <WeatherDate date={weatherByTime.dt_txt} />
        <WeatherCondition day={weatherByTime.sys.pod} weatherCondition={props.day[0].weather[0].description} />
        <div>
          <span className="txt-regular m-1">{Math.trunc(weatherByTime.main.temp_min)} °</span>
          <span className="txt-regular m-1">{Math.trunc(weatherByTime.main.temp_max)} °</span>
        </div>
      </div>
    ))}
  </div>
);

const WeatherCondition = props => {
  let icon = null;
  const { day, weatherCondition } = props;
  if (weatherCondition === 'clear sky') {
    if (day) {
      if (day === 'd') {
        icon = ClearSky;
      } else {
        icon = ClearSkyNight;
      }
    } else {
      icon = ClearSky;
    }
  } else if (weatherCondition === 'few clouds') {
    if (day) {
      if (day === 'd') {
        icon = FewClouds;
      } else {
        icon = FewCloudsNight;
      }
    } else {
      icon = FewClouds;
    }
  } else if (weatherCondition === 'scattered clouds') {
    icon = LotOfClouds;
  } else if (weatherCondition === 'rain') {
    icon = Rain;
  } else {
    icon = FewClouds;
  }
  return <img className="mb-2" src={icon} style={{ marginLeft: 'auto', marginRight: 'auto' }} width={props.large ? 150 : 50} />;
};

const WeatherDate = props => <span className="txt-thin mb-2"> {getHoursFromDate(new Date(props.date))} </span>;

function getHoursFromDate(date) {
  return `${date.getHours()}:00`;
}



// WEBPACK FOOTER //
// ./src/components/Weather.js